<i18n
  src="@/locales/views/customer/reporting/process/show_report.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="customer_reporting_process_list_reports_path"
    :params="{
      customer_id: customer_id,
      agro_exporter_id: agro_exporter_id,
      agro_exporter_process_id: agro_exporter_process_id
    }"
  />

  <bread-crumbs
    :labels="[
      module_name,
      agro_exporter?.name,
      agro_exporter_process?.name,
      customer_report_name
    ]"
  ></bread-crumbs>

  <div v-if="load_data_general" class="mt-6">
    <div class="mt-8 flex flex-col">
      <div
        class="bg-white rounded-md flex"
        v-if="series_data.length > 0 && chart_options"
      >
        <div class="rounded-md px-6 flex-1 pt-4">
          <apexchart
            height="500"
            :options="chart_options"
            :series="series_data"
          ></apexchart>
        </div>
      </div>
    </div>
  </div>
  <loading-message v-else />
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

import Requester from "@/views/customer/requesters/reporting/process/list_reports.js";

export default {
  components: {
    apexchart: VueApexCharts
  },
  name: "AEQualityReportsProcessListReports",
  props: [
    "customer_id",
    "agro_exporter_id",
    "agro_exporter_process_id",
    "customer_report_id"
  ],
  data() {
    return {
      load_data_general: false,
      agro_exporter: {},
      agro_exporter_process: {},
      customer_report: null,
      customer_report_name: ""
    };
  },
  computed: {
    series_data() {
      if (this.customer_report == null) return [];
      return this.customer_report.series.map(serie => {
        return {
          name: serie.name,
          type: serie.graph_type,
          data: serie.data
        };
      });
    },
    chart_options() {
      if (this.customer_report == null) return null;
      return {
        chart: {
          height: 350,
          stacked: this.customer_report.stacked
        },
        legend: {
          position: "top"
        },
        stroke: {
          width: this.customer_report.series.map(serie => serie.stroke)
        },
        dataLabels: {
          enabled: false
        },
        labels: this.customer_report.xaxis.labels,
        yaxis: this.y_axis,
        colors: this.colors,
        annotations: {
          yaxis: this.y_annotations
        },
        xaxis: this.x_axis
      };
    },
    colors() {
      let colors = this.customer_report.colors;
      return this.customer_report.series.map((serie, i) => {
        return serie.color || colors[i];
      });
    },
    x_axis() {
      return {
        title: {
          text: this.customer_report.xaxis.title
        },
        labels: {
          rotate: -45,
          rotateAlways: true
        }
      };
    },
    y_axis() {
      return this.customer_report.series.map(serie => {
        let axis = {
          title: {
            text: serie.label
          },
          opposite: serie.yaxis.opposite,
          show: serie.yaxis.show,
          min: serie.yaxis.min,
          labels: {
            formatter: function (val) {
              if (val == null) return val;
              else if (Number.isSafeInteger(val)) return val.toFixed(0);
              else return val.toFixed(2);
            }
          }
        };
        if (serie.graph_type == "column") {
          axis["max"] = serie.yaxis.max || this.max_value;
        } else if (serie.graph_type == "line") {
          axis["max"] = serie.yaxis.max || null;
        }
        if (serie.yaxis.steps_number) {
          axis["tickAmount"] = serie.yaxis.steps_number;
        }
        return axis;
      });
    },
    max_value() {
      let serie_data = this.customer_report.series
        .filter(serie => serie.graph_type == "column")
        .map(serie => serie.data);

      let max_value = 0;

      for (let index = 0; index < serie_data[0].length; index++) {
        let new_max = serie_data.reduce((acc, curr) => {
          return acc + curr[index];
        }, 0);
        if (new_max > max_value) max_value = new_max;
      }
      return max_value;
    },
    y_annotations() {
      return this.customer_report.y_annotations.map(annotation => {
        return {
          y: annotation.y,
          strokeDashArray: 0,
          borderColor: annotation.color,
          yAxisIndex: annotation.serieIndex,
          label: {
            borderColor: annotation.color,
            style: {
              color: annotation.color
            },
            text: annotation.label,
            offsetY: 5,
            offsetX: 25
          }
        };
      });
    }
  },
  methods: {
    fetchAgroExporter: async function () {
      let response = await Requester.fetchAgroExporter(
        this.customer_id,
        this.agro_exporter_id
      );
      this.agro_exporter = response.data;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.customer_id,
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchCustomerReport: async function () {
      let response = await Requester.fetchCustomerReport(
        this.customer_id,
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.customer_report_id
      );
      this.customer_report_name = response.data.name;
      this.customer_report = response.data.report;
      this.load_data_general = true;
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchAgroExporter();
        this.fetchAgroExporterProcess();
        this.fetchCustomerReport();
      })
    );
  }
};
</script>
